/* eslint-disable jsx-a11y/img-redundant-alt */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from "react";
import ENDPOINTS from "../../services/endPoints";
import QUERY_KEYS from "../../services/queryKeys";
import usePost from "../../hooks/usePost";
import useGet from "../../hooks/useGet";
import usePut from "../../hooks/usePut";
import { useFormik } from "formik";
import {
  addAboutUsInitialValues,
  addAboutUsValidationSchema,
} from "../../utils/validations/aboutUs";
import { toast } from "react-toastify";
import CustomModal from "../../components/customModal/customModal";
import SkillListingSkeleton from "../../utils/skeleton/skillListingSkeleton";
import NotFound from "../../components/notFound";
import useDelete from "../../hooks/useDelete";

const AboutUs = () => {
  const [deleteSkillModal, setDeleteSkillModal] = useState(false);
  const [deleteAboutUsId, setDeleteAboutUsId] = useState(null);

  const [uploadImg, setUploadImg] = useState(null);
  const [aboutUsModal, setAboutUsModal] = useState({
    title: "",
    data: {},
    open: false,
    type: "",
    actionTitle: "",
    onConfirm: null,
  });
  const uploadImageRef = useRef(null);
  const { mutateAsync: addAboutUsMutateAsync, isLoading: isLoadingAddAboutUs } =
    usePost(ENDPOINTS.ADD_ABOUT_US, QUERY_KEYS.ADD_ABOUT_US_QUERY_KEY);
  const {
    data: aboutUsListData,
    isLoading: isLoadingAboutUs,
    refetch: refetchAboutUsList,
  } = useGet(ENDPOINTS.ABOUT_US, QUERY_KEYS.ABOUT_US_QUERY_KEY);

  const aboutUsData = aboutUsListData?.data?.our_missions;
  const { mutateAsync: editSkillMutateAsync, isLoading: isLoadingEditSkill } =
    usePut(ENDPOINTS.EDIT_ABOUT_US, QUERY_KEYS.EDIT_ABOUT_US_QUERY_KEY);

  const {
    isLoading: isLoadingAboutUsDelete,
    mutateAsync: aboutUsDeleteMutateAsync,
  } = useDelete(
    ENDPOINTS.DELETE_ABOUT_US,
    QUERY_KEYS.DELETE_ABOUT_US_QUERY_KEY
  );

  const {
    errors,
    handleBlur,
    handleChange,
    touched,
    resetForm,
    handleSubmit,
    values,
    setValues,
    setFieldValue,
  } = useFormik({
    initialValues: addAboutUsInitialValues,
    validationSchema: addAboutUsValidationSchema,
    onSubmit: async (values) => {
      if (aboutUsModal.type === "Add") {
        const formData = new FormData();
        formData.append("title", values?.aboutTitle);
        formData.append("description", values?.aboutDescription);
        formData.append("image", values?.aboutImage);
        try {
          const response = await addAboutUsMutateAsync(formData);
          if (response.statusCode === 201) {
            toast.success(response?.message);
            handleCloseModal();
            refetchAboutUsList();
          } else {
            toast.error(response?.message);
          }
        } catch (error) {
          toast.error(error.response.data.message);
        }
      } else if (aboutUsModal.type === "Edit") {
        const formData = new FormData();
        formData.append("_id", aboutUsModal?.data?._id);
        formData.append("title", values?.aboutTitle);
        formData.append("description", values?.aboutDescription);
        formData.append("image", values?.aboutImage);
        try {
          const response = await editSkillMutateAsync(formData);
          if (response.statusCode === 200) {
            toast.success(response?.message);
            handleCloseModal();
            refetchAboutUsList();
          } else {
            toast.error(response?.message);
          }
        } catch (error) {
          toast.error(error.response.data.message);
        }
      }
    },
  });

  const onChangeFile = (target) => {
    const selectedFile = target.files[0];
    setUploadImg(URL.createObjectURL(selectedFile));
    setFieldValue("aboutImage", selectedFile);
    target.value = "";
  };

  const handleSelectUploadImage = () => {
    if (uploadImageRef.current) {
      uploadImageRef.current.click();
    }
  };

  const handelRemoveUploadImg = () => {
    setUploadImg(null);
    setFieldValue("aboutImage", "");
  };

  const handelDeleteSkillModal = (id) => {
    setDeleteAboutUsId(id);
    setDeleteSkillModal(true);
  };
  const onDeleteConfirm = async () => {
    try {
      const response = await aboutUsDeleteMutateAsync({
        _id: deleteAboutUsId,
      });
      if (response.status === true) {
        toast.success(response?.message);
        setDeleteSkillModal(false);
        refetchAboutUsList();
      } else {
        toast.error(response?.message);
      }
    } catch (error) {
      toast.error(error.response.data.message);
    }
  };

  const handleModalOpen = (e, item) => {
    if (e.target.title === "Add") {
      setAboutUsModal({
        open: true,
        title: "Add About Us",
        actionTitle: "Add",
        type: e.target.title,
        onConfirm: handleSubmit,
        data: {},
      });
    } else if (e.target.title === "Edit") {
      setAboutUsModal({
        open: true,
        title: "Edit About Us",
        actionTitle: "Save",
        type: e.target.title,
        onConfirm: handleSubmit,
        data: item,
      });
    } else return null;
  };

  const returnModal = () => {
    if (aboutUsModal.type === "Add") {
      return (
        <CustomModal
          open={aboutUsModal.open}
          title={aboutUsModal.title}
          actionTitle={aboutUsModal.actionTitle}
          cancelTitle={"Cancel"}
          actionButtonClass={"bg-danger"}
          onConfirm={aboutUsModal.onConfirm}
          isLoading={isLoadingAddAboutUs}
          onClose={handleCloseModal}
        >
          <div>
            <form>
              <div className="upload_container">
                <div>
                  <div className="drag-input-field">
                    <label>Upload Image </label>
                    <input
                      type="file"
                      accept="image/*"
                      name="aboutImage"
                      onBlur={handleBlur}
                      onChange={({ target }) => {
                        onChangeFile(target);
                      }}
                      ref={uploadImageRef}
                    />
                    {values?.aboutImage?.length === 0 ? (
                      <label className="m-0" onClick={handleSelectUploadImage}>
                        <span className="upload-text">
                          <i className="fa-solid fa-cloud-arrow-up" />
                          Upload
                        </span>
                      </label>
                    ) : (
                      <div className="position-relative ">
                        <img
                          src={uploadImg}
                          style={{
                            height: "200px",
                            width: "200px",

                            objectFit: "contain",
                            borderRadius: "5px",
                            border: "solid 1px #8080808a",
                          }}
                          alt="..."
                        />
                        <button
                          className="removeimg"
                          type="button"
                          onClick={() => handelRemoveUploadImg()}
                        >
                          X
                        </button>
                      </div>
                    )}
                  </div>
                  {touched.aboutImage && errors.aboutImage && (
                    <p className="error" style={{ marginTop: "4px" }}>
                      {errors.aboutImage}
                    </p>
                  )}
                </div>
                <div>
                  <div className="mb-3">
                    <label> Title</label>
                    <input
                      type="text"
                      className="form-control form-control-lg"
                      placeholder="Enter Title"
                      name="aboutTitle"
                      value={values.aboutTitle}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />
                  </div>
                  {touched.aboutTitle && errors.aboutTitle && (
                    <p className="error">{errors.aboutTitle}</p>
                  )}
                  <div className="mb-3">
                    <label> Description </label>
                    <textarea
                      className="form-control form-control-lg"
                      placeholder="Enter  Description"
                      rows="3"
                      cols="50"
                      name="aboutDescription"
                      value={values.aboutDescription}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    ></textarea>
                  </div>
                  {touched.aboutDescription && errors.aboutDescription && (
                    <p className="error">{errors.aboutDescription}</p>
                  )}
                </div>
              </div>
            </form>
          </div>
        </CustomModal>
      );
    } else if (aboutUsModal.type === "Edit") {
      return (
        <CustomModal
          open={aboutUsModal.open}
          title={aboutUsModal.title}
          actionTitle={aboutUsModal.actionTitle}
          cancelTitle={"Cancel"}
          actionButtonClass={"bg-danger"}
          onConfirm={aboutUsModal.onConfirm}
          isLoading={isLoadingEditSkill}
          onClose={handleCloseModal}
        >
          <div>
            <form>
              <div className="upload_container">
                <div>
                  <div className="drag-input-field">
                    <label>Upload Image </label>
                    <input
                      type="file"
                      accept="image/*"
                      name="aboutImage"
                      onBlur={handleBlur}
                      onChange={({ target }) => {
                        onChangeFile(target);
                      }}
                      ref={uploadImageRef}
                    />
                    {values?.aboutImage?.length === 0 ? (
                      <label className="m-0" onClick={handleSelectUploadImage}>
                        <span className="upload-text">
                          <i className="fa-solid fa-cloud-arrow-up" />
                          Upload
                        </span>
                      </label>
                    ) : (
                      <div className="position-relative ">
                        <img
                          src={
                            uploadImg === null ? values.aboutImage : uploadImg
                          }
                          style={{
                            height: "200px",
                            width: "100%",
                            objectFit: "cover",
                            borderRadius: "5px",
                          }}
                          alt="..."
                        />
                        <button
                          className="removeimg"
                          type="button"
                          onClick={() => handelRemoveUploadImg()}
                        >
                          X
                        </button>
                      </div>
                    )}
                  </div>
                  {touched.aboutImage && errors.aboutImage && (
                    <p className="error" style={{ marginTop: "4px" }}>
                      {errors.aboutImage}
                    </p>
                  )}
                </div>
                <div>
                  <div className="mb-3">
                    <label> Title</label>
                    <input
                      type="text"
                      className="form-control form-control-lg"
                      placeholder="Enter Title"
                      name="aboutTitle"
                      value={values.aboutTitle}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />
                  </div>
                  {touched.aboutTitle && errors.aboutTitle && (
                    <p className="error">{errors.aboutTitle}</p>
                  )}
                  <div className="mb-3">
                    <label> Description </label>
                    <textarea
                      className="form-control form-control-lg"
                      placeholder="Enter  Description"
                      rows="3"
                      cols="50"
                      name="aboutDescription"
                      value={values.aboutDescription}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    ></textarea>
                  </div>
                  {touched.skillDescription && errors.skillDescription && (
                    <p className="error">{errors.skillDescription}</p>
                  )}
                </div>
              </div>
            </form>
          </div>
        </CustomModal>
      );
    } else return null;
  };

  const handleCloseModal = () => {
    setAboutUsModal({
      open: false,
      data: {},
    });
    resetForm();
  };

  useEffect(() => {
    if (aboutUsModal.type === "Edit") {
      setValues({
        aboutTitle: aboutUsModal?.data?.title,
        aboutDescription: aboutUsModal?.data?.description,
        aboutImage: aboutUsModal?.data?.image,
      });
    }
  }, [aboutUsModal?.data]);

  return (
    <div>
      <div>
        <div className="row">
          <div className="col-md-12 mt-4 px-1">
            <div className="card">
              <div className="card-header pb-0 px-3">
                <div className="position-relative my-3 d-flex justify-center">
                  <h5 className="mb-0">About Us List</h5>
                  {isLoadingAboutUs ? null : (
                    <button
                      title="Add"
                      type="button"
                      className="btn btn-green text-uppercase position-absolute top-0 end-0 "
                      onClick={(e) => handleModalOpen(e)}
                    >
                      Add About Us
                    </button>
                  )}
                </div>
              </div>
              <div className="card-body pt-4 p-3">
                {isLoadingAboutUs ? (
                  <SkillListingSkeleton />
                ) : (
                  <ul className="list-group">
                    {!aboutUsData ? (
                      <NotFound content="About Us List Not Found" />
                    ) : (
                      aboutUsData?.map((item, index) => {
                        return (
                          <li
                            className="list-group-item border-0 p-4 mb-2 bg-gray-100 border-radius-lg"
                            key={index}
                          >
                            <div className="row justify-content-between gy-3">
                              <div className="card-flex d-flex cursor-pointer col-sm-10">
                                <img
                                  src={item.image}
                                  alt="Image"
                                  className="item-img rounded-2"
                                />

                                <div className="item-content d-flex flex-column ">
                                  <h6 className="mb-3 text-lg">{item.title}</h6>
                                  <span className="mb-2 text-md">
                                    <span className="text-dark font-weight-normal">
                                      {item.description}
                                    </span>
                                  </span>
                                </div>
                              </div>

                              <div className="col-sm-2 align-self-end ms-sm-auto text-end">
                                <a
                                  className="btn btn-link text-danger text-gradient px-3 mb-0"
                                  onClick={() =>
                                    handelDeleteSkillModal(item?._id)
                                  }
                                >
                                  <i className="far fa-trash-alt me-2" />
                                  Delete
                                </a>
                                <a
                                  title="Edit"
                                  className="btn btn-link text-dark px-3 mb-0"
                                  onClick={(e) => handleModalOpen(e, item)}
                                >
                                  <i
                                    className="fas fa-pencil-alt text-dark me-2"
                                    aria-hidden="true"
                                  />
                                  Edit
                                </a>
                              </div>
                            </div>
                          </li>
                        );
                      })
                    )}
                  </ul>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      {returnModal()}
      <CustomModal
        customClass="sm-modal"
        open={deleteSkillModal}
        title={"About Us Delete"}
        actionTitle={"Delete"}
        cancelTitle={"Cancel"}
        actionButtonClass={"bg-danger"}
        onConfirm={onDeleteConfirm}
        isLoading={isLoadingAboutUsDelete}
        onClose={() => setDeleteSkillModal(false)}
      >
        <div>
          <span>Are you sure you want to delete About Us?</span>
        </div>
      </CustomModal>
    </div>
  );
};

export default AboutUs;
